module.exports = __webpack_public_path__ + "img/pds_config_3.65bb72d3.svg";